// jsz
import engagementCompositeForm from './engagementCompositeForm';
import EngagementTeamItem from './EngagementTeamItem';


export default engagementCompositeForm({
  title: 'Teams Interviewed',
  className: 'analytics__engagement-teams-interviewed-form',
  itemName: 'Team',
  displayName: 'EngagementTeamsInterviewedForm',
  itemComponent: EngagementTeamItem
});



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementTeamsInterviewedForm.js